import { IconDateTime16, Icon3DTour16, IconVideo16 } from '@cian/ui-kit';
import { ReactNode, useMemo } from 'react';
import { FeatureLabels } from '../../components/FeatureLabels';
import { useGallery } from '../../hooks';

const assetMap: Record<string, ReactNode> = {
  has3dTour: <Icon3DTour16 color={'white_100'} data-name="3D-tour-icon" />,
  hasFlatTourBooking: <IconDateTime16 color={'white_100'} />,
  hasVideo: <IconVideo16 color={'white_100'} />,
};

export function FeatureLabelsContainer() {
  const { badges } = useGallery();

  const labels = useMemo(
    () => (badges?.length ? badges.map(({ type, text }) => ({ icon: assetMap[type], tooltip: text })) : null),
    [badges],
  );

  if (!labels) {
    return null;
  }

  return <FeatureLabels items={labels} />;
}
